<div class="space-y-4">
  <h2 class="mb-4">What happens when you activate</h2>

  <ul class="space-y-3 list-disc text-text-tertiary pl-4 leading-normal">
    <li>
      Autopilot will add cleaning tasks to bookings created after activation. For example, if you get a new booking
      tomorrow, an autopilot cleaning task will be created for it automatically.
    </li>
    <li>Your existing after checkout cleaning tasks will stay as they are.</li>
    <li> Any current after checkout cleaning task rule will be turned off and replaced with an autopilot rule. </li>
    @if (
      turnoIntegrationEnabled() ||
      cleansterIntegrationEnabled() ||
      resortCleaningIntegrationEnabled() ||
      tidyIntegrationEnabled()
    ) {
      <li>
        If you use an integration (e.g. {{ activeIntegrations() }}), you'll need to disable task creation there to avoid
        duplicates.
      </li>
    }
  </ul>
</div>
